import React from 'react';
import { Box, Container, Typography, Card, CardContent } from '@mui/material';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import PaletteIcon from '@mui/icons-material/Palette';
import SecurityIcon from '@mui/icons-material/Security';
import BarChartIcon from '@mui/icons-material/BarChart';
import PublicIcon from '@mui/icons-material/Public';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const FeaturesSection: React.FC = () => {
  const features = [
    { icon: <FlashOnIcon fontSize="large" />, title: 'Lightning Fast', description: 'Get screenshots in milliseconds with our optimized infrastructure' },
    { icon: <PaletteIcon fontSize="large" />, title: 'Fully Customizable', description: 'Control viewport size, format, quality, and more' },
    { icon: <SecurityIcon fontSize="large" />, title: 'Secure & Reliable', description: 'Enterprise-grade security with 99.9% uptime SLA' },
    { icon: <BarChartIcon fontSize="large" />, title: 'Real-time Analytics', description: 'Track usage, monitor performance, and optimize costs' },
    { icon: <PublicIcon fontSize="large" />, title: 'Global CDN', description: 'Distributed servers worldwide for minimal latency' },
    { icon: <AttachMoneyIcon fontSize="large" />, title: 'Flexible Pricing', description: 'Pay only for what you use with transparent pricing' },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 10 }}>
      <Typography variant="h3" align="center" gutterBottom sx={{ mb: 6 }}>
        Why Choose Our API?
      </Typography>
      <Box sx={{ 
        display: 'grid', 
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
        gap: 4
      }}>
        {features.map((feature, index) => (
          <Card key={index} sx={{ 
            height: '100%', 
            transition: 'transform 0.2s',
            '&:hover': { transform: 'translateY(-8px)', boxShadow: '0 8px 24px rgba(0,0,0,0.15)' }
          }}>
            <CardContent sx={{ textAlign: 'center', p: 4 }}>
              <Box sx={{ mb: 2 }}>{feature.icon}</Box>
              <Typography variant="h6" gutterBottom>
                {feature.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {feature.description}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>
  );
};

export default FeaturesSection;

